<template>
  <div v-if="model.params.done">
    <span v-if="model.results.length">
      <b><translate>Results:</translate> {{ model.params.resortName}} -
        {{ model.params.checkIn }} /
        {{ duration }} <translate>nights</translate>:</b>
      <strong>&nbsp;{{ model.results.length }}</strong> <translate>results</translate>
      <!-- {{ model.params}} -->
    </span>
    <span v-else v-translate>
      There are no results for your search.
      Please change your search criteria
    </span>

  </div>
</template>

<script>
import moment from 'moment'
import model from '../services/model'

export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>
